import React from "react";
import {
  Divider,
  Typography,
  IconButton,
  ListItem,
  ListItemText,
  List,
  Paper,
  ListItemSecondaryAction,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const FormStates = ({ formStates = {}, handleUse, handleDelete }) => (
  <Paper style={{ width: "300px", padding: "16px" }}>
    <Typography variant="h6">Saved Form States</Typography>
    <Divider />
    <List>
      {Object.keys(formStates).map((key) => (
        <ListItem key={key}>
          <ListItemText primary={key} />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => handleUse(key)}
              edge="end"
              aria-label="use"
            >
              <ArrowForwardIcon />
            </IconButton>
            <IconButton
              onClick={() => handleDelete(key)}
              edge="end"
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  </Paper>
);

export default FormStates;
